import { CSSProperties } from "react";
import style from "styled-jsx/style";

export const WalletMinusSvg = ({
  fill = "white",
  style = undefined,
}: {
  fill: string;
  style: CSSProperties | undefined;
}) => {
  return (
    <>
      <svg
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.0002 12.6216V14.6816C22.0002 15.2416 21.5402 15.7016 20.9702 15.7016H19.0402C17.9602 15.7016 16.9702 14.9116 16.8802 13.8316C16.8202 13.2016 17.0602 12.6116 17.4802 12.2016C17.8502 11.8216 18.3602 11.6016 18.9202 11.6016H20.9702C21.5402 11.6016 22.0002 12.0616 22.0002 12.6216Z"
          style={style}
          fill={fill}
        />
        <path
          d="M15.38 13.9584C15.29 12.9084 15.67 11.8784 16.43 11.1284C17.07 10.4784 17.96 10.0984 18.92 10.0984H19.49C19.77 10.0984 20 9.86844 19.96 9.58844C19.69 7.64844 18.01 6.14844 16 6.14844H6C3.79 6.14844 2 7.93844 2 10.1484V17.1484C2 19.3584 3.79 21.1484 6 21.1484H16C18.02 21.1484 19.69 19.6484 19.96 17.7084C20 17.4284 19.77 17.1984 19.49 17.1984H19.04C17.14 17.1984 15.54 15.7784 15.38 13.9584ZM13 11.8984H7C6.59 11.8984 6.25 11.5684 6.25 11.1484C6.25 10.7284 6.59 10.3984 7 10.3984H13C13.41 10.3984 13.75 10.7384 13.75 11.1484C13.75 11.5584 13.41 11.8984 13 11.8984Z"
          style={style}
          fill={fill}
        />
        <path
          d="M14.2106 3.98156C14.4706 4.25156 14.2406 4.65156 13.8606 4.65156H6.03064C4.94064 4.65156 3.92064 4.97156 3.07064 5.52156C2.68064 5.77156 2.15064 5.50156 2.34064 5.07156C2.90064 3.76156 4.21064 2.85156 5.72064 2.85156H11.3406C12.5006 2.85156 13.5306 3.26156 14.2106 3.98156Z"
          style={style}
          fill={fill}
        />
      </svg>
    </>
  );
};

export const WalletAddSvg = ({
  fill = "white",
  style = undefined,
}: {
  fill: string;
  style: CSSProperties | undefined;
}) => {
  return (
    <>
      <svg
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 15C2.79 15 1 16.79 1 19C1 19.75 1.21 20.46 1.58 21.06C2.27 22.22 3.54 23 5 23C6.46 23 7.73 22.22 8.42 21.06C8.79 20.46 9 19.75 9 19C9 16.79 7.21 15 5 15ZM6.49 19.73H5.75V20.51C5.75 20.92 5.41 21.26 5 21.26C4.59 21.26 4.25 20.92 4.25 20.51V19.73H3.51C3.1 19.73 2.76 19.39 2.76 18.98C2.76 18.57 3.1 18.23 3.51 18.23H4.25V17.52C4.25 17.11 4.59 16.77 5 16.77C5.41 16.77 5.75 17.11 5.75 17.52V18.23H6.49C6.9 18.23 7.24 18.57 7.24 18.98C7.24 19.39 6.91 19.73 6.49 19.73Z"
          style={style}
          fill={fill}
        />
        <path
          d="M21.5 12.5H19C17.9 12.5 17 13.4 17 14.5C17 15.6 17.9 16.5 19 16.5H21.5C21.78 16.5 22 16.28 22 16V13C22 12.72 21.78 12.5 21.5 12.5Z"
          style={style}
          fill={fill}
        />
        <path
          d="M16.5292 5.40016C16.8292 5.69016 16.5792 6.14016 16.1592 6.14016L7.87923 6.13016C7.39923 6.13016 7.15923 5.55016 7.49923 5.21016L9.24923 3.45016C10.7292 1.98016 13.1192 1.98016 14.5992 3.45016L16.4892 5.36016C16.4992 5.37016 16.5192 5.39016 16.5292 5.40016Z"
          style={style}
          fill={fill}
        />
        <path
          d="M21.8694 18.66C21.2594 20.72 19.4994 22 17.0994 22H10.5994C10.2094 22 9.95938 21.57 10.1194 21.21C10.4194 20.51 10.6094 19.72 10.6094 19C10.6094 15.97 8.13938 13.5 5.10938 13.5C4.34938 13.5 3.60938 13.66 2.92938 13.96C2.55938 14.12 2.10938 13.87 2.10938 13.47V12C2.10938 9.28 3.74938 7.38 6.29938 7.06C6.54938 7.02 6.81937 7 7.09937 7H17.0994C17.3594 7 17.6094 7.01 17.8494 7.05C19.8694 7.28 21.3294 8.51 21.8694 10.34C21.9694 10.67 21.7294 11 21.3894 11H19.0994C16.9294 11 15.2094 12.98 15.6794 15.23C16.0094 16.87 17.5294 18 19.1994 18H21.3894C21.7394 18 21.9694 18.34 21.8694 18.66Z"
          style={style}
          fill={fill}
        />
      </svg>
    </>
  );
};

// Investment-related SVG icons
export const SecuritySvg = ({
  fill = "white",
  style = undefined,
}: {
  fill: string;
  style: CSSProperties | undefined;
}) => {
  return (
    <svg
      style={style}
      fill={fill}
      version="1.1"
      viewBox="0 0 1800 1800"
      enableBackground="new 0 0 1800 1800"
    >
      <g>
        <path
          style={style}
          fill={fill}
          d="M1590.487,1148.496V645.409C1648.671,631.251,1692,578.732,1692,516.255
		c0-73.311-59.631-132.951-132.941-132.951c-38.059,0-72.407,16.104-96.673,41.83l-437.927-252.835
		c3.481-11.86,5.375-24.388,5.375-37.357C1029.834,61.64,970.203,2,896.895,2c-73.302,0-132.941,59.64-132.941,132.942
		c0,12.969,1.903,25.497,5.384,37.357L331.416,425.129c-24.255-25.725-58.609-41.825-96.667-41.825
		c-73.311,0-132.95,59.64-132.95,132.951c0,62.472,43.333,114.991,101.512,129.154v503.093
		c-58.179,14.161-101.512,66.68-101.512,129.156c0,73.302,59.639,132.942,132.95,132.942c36.406,0,69.431-14.72,93.467-38.51
		l441.122,254.681c-3.481,11.86-5.384,24.388-5.384,37.356c0,73.304,59.64,132.942,132.941,132.942
		c73.309,0,132.939-59.639,132.939-132.942c0-12.969-1.894-25.496-5.375-37.356l441.128-254.69
		c24.036,23.796,57.062,38.52,93.472,38.52c73.311,0,132.941-59.641,132.941-132.942
		C1692,1215.178,1648.671,1162.653,1590.487,1148.496z M1489.476,1285.709c-0.299-2.645-0.5-5.323-0.5-8.051
		c0-27.333,15.766-51.006,38.645-62.555c9.473-4.78,20.126-7.533,31.438-7.533c11.304,0,21.958,2.753,31.42,7.529
		c22.896,11.545,38.664,35.216,38.664,62.559c0,38.646-31.438,70.084-70.084,70.084c-12.742,0-24.659-3.473-34.963-9.439
		C1505.347,1327.45,1492.061,1308.205,1489.476,1285.709z M1519.764,458.255c11.216-7.625,24.738-12.093,39.295-12.093
		c38.646,0,70.084,31.442,70.084,70.093c0,27.338-15.768,51.006-38.655,62.555c-9.462,4.775-20.116,7.528-31.429,7.528
		c-11.304,0-21.959-2.753-31.43-7.533c-22.888-11.545-38.653-35.213-38.653-62.551c0-1.048,0.113-2.066,0.156-3.1
		C1490.141,490.351,1502.006,470.331,1519.764,458.255z M826.811,134.942c0-38.646,31.438-70.084,70.083-70.084
		c38.645,0,70.082,31.438,70.082,70.084c0,1.368-0.123,2.701-0.201,4.051c-1.308,22.747-13.443,42.614-31.396,54.457
		c-11.057,7.296-24.272,11.576-38.485,11.576c-14.206,0-27.421-4.28-38.479-11.576c-17.95-11.843-30.087-31.71-31.394-54.457
		C826.942,137.643,826.811,136.31,826.811,134.942z M164.656,516.255c0-38.651,31.442-70.093,70.092-70.093
		c14.553,0,28.08,4.463,39.295,12.088c17.758,12.071,29.627,32.096,30.631,54.9c0.048,1.035,0.158,2.056,0.158,3.104
		c0,27.342-15.772,51.01-38.664,62.559c-9.466,4.771-20.116,7.524-31.42,7.524c-11.312,0-21.971-2.753-31.438-7.533
		C180.422,567.257,164.656,543.589,164.656,516.255z M269.707,1338.311c-10.304,5.965-22.221,9.432-34.958,9.432
		c-38.65,0-70.092-31.438-70.092-70.084c0-27.337,15.767-51.006,38.654-62.555c9.467-4.78,20.126-7.533,31.438-7.533
		c11.304,0,21.954,2.753,31.42,7.523c22.892,11.551,38.664,35.222,38.664,62.564c0,2.731-0.198,5.41-0.5,8.059
		C301.741,1308.215,288.46,1327.46,269.707,1338.311z M966.977,1664.128c0,38.646-31.438,70.084-70.082,70.084
		c-38.646,0-70.083-31.438-70.083-70.084c0-1.368,0.131-2.704,0.21-4.051c1.307-22.743,13.444-42.615,31.394-54.462
		c11.058-7.295,24.273-11.575,38.479-11.575c14.213,0,27.429,4.28,38.485,11.575c17.952,11.847,30.088,31.719,31.396,54.462
		C966.854,1661.424,966.977,1662.76,966.977,1664.128z M992.959,1572.372c-24.22-25.349-58.314-41.19-96.064-41.19
		c-37.743,0-71.837,15.842-96.059,41.19l-439.614-253.809c4.183-12.892,6.467-26.633,6.467-40.905
		c0-62.48-43.337-115.005-101.521-129.162V645.413c58.185-14.158,101.521-66.681,101.521-129.158c0-12.663-1.819-24.905-5.143-36.52
		l438.289-253.042c24.221,25.352,58.315,41.189,96.059,41.189c37.75,0,71.845-15.837,96.064-41.189l438.297,253.046
		c-3.314,11.61-5.139,23.853-5.139,36.515c0,62.472,43.337,114.991,101.512,129.154l-0.009,503.093
		c-58.174,14.161-101.503,66.68-101.503,129.156c0,14.269,2.289,28.004,6.471,40.897L992.959,1572.372z"
        />
        <path
          style={style}
          fill={fill}
          d="M1264.597,747.992L916.255,475.829c-11.365-8.884-27.332-8.884-38.696,0L529.218,747.992
		c-7.63,5.954-12.084,15.092-12.084,24.764c0,233.561,100.426,372.219,184.671,447.416
		c91.516,81.682,182.901,107.541,186.742,108.604c2.736,0.753,5.55,1.131,8.357,1.131c2.815,0,5.628-0.378,8.355-1.131
		c3.849-1.063,95.225-26.922,186.74-108.604c84.247-75.197,184.673-213.855,184.673-447.416
		C1276.672,763.083,1272.216,753.946,1264.597,747.992z M1052.223,1171.406c-65.664,59.303-132.381,86.044-155.372,94.063
		c-22.677-7.841-87.754-33.792-153.19-92.195c-105.319-94.003-160.293-223.577-163.521-385.308l316.763-247.491l316.761,247.491
		C1210.464,948.58,1156.191,1077.519,1052.223,1171.406z"
        />
      </g>
    </svg>
  );
};

export const HierarchySvg = ({
  fill = "white",
  style = undefined,
}: {
  fill: string;
  style: CSSProperties | undefined;
}) => {
  return (
    <svg style={style} fill={fill} version="1.1" viewBox="0 0 484.53 484.53">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M169.307,96.83L169.307,96.83c0.1,0,0.2,0,0.3,0s0.2,0,0.3,0l0,0c43.5-0.5,37.2-58.5,37.2-58.5 c-1.8-38.8-34.2-38.5-37.4-38.3c-3.2-0.1-35.6-0.5-37.4,38.3C132.107,38.33,125.807,96.43,169.307,96.83z"></path>{" "}
            <path d="M356.807,215.83l-76.2-21.7l-35.9-56.3l0,0c-0.4-0.6-0.8-1.1-1.2-1.5c-3.8-3.8-5.7-5.6-9.9-8.7 c-16.1-11.9-35.9-19.9-35.9-19.9l-15.1,47.7l-8.8-25c15.8-22.1-1.9-22.7-4.2-22.7c-2.4,0-20.1,0.6-4.2,22.7l-8.8,25l-15.1-47.7 c0,0-19.8,8-35.9,19.9c-4.2,3.1-6.1,5-9.9,8.7c-8.9,8.9-5.2,60.7,0,79.7s20.3,46.1,20.3,46.1c3,6.9,5,14.3,5.7,21.8l19.3,190 c0.6,6,5.7,10.6,11.8,10.6h16.8h16.7c6.1,0,11.2-4.6,11.8-10.6l14.5-142l0.3-3.3l4.6-44.7l0,0l9.3-91c0.1-1.4,1.9-1.8,2.7-0.7 l18.5,26.4c3.1,4.4,7.7,7.4,12.9,8.4l89.1,17.4c7.5,1.5,14.9-3.1,17-10.5C369.107,226.13,364.607,218.03,356.807,215.83z"></path>{" "}
            <path d="M377.107,122.63c-5.5-2.9-11.3-5.1-17-7.4c-3.3-1.3-6.5-2.9-9.4-5.1c-5.6-4.3-4.6-11.5,1.8-14.4c1.8-0.8,3.7-1.1,5.7-1.2 c7.5-0.5,14.6,0.7,21.4,3.9c3.4,1.6,4.5,1.1,5.6-2.5c1.1-3.7,2.1-7.5,3.1-11.3c0.7-2.5-0.2-4.2-2.6-5.2c-4.4-1.8-8.8-3.2-13.5-3.8 c-6.1-0.9-6.1-0.9-6.2-7c-0.2-8.7-0.2-8.7-8.8-8.5c-1.3,0-2.5,0-3.8,0.1c-4.1,0.2-4.7,0.9-4.8,5c0,1.8,0,3.7,0.1,5.5 c0.1,5.4,0,5.4-5.1,7.3c-12.5,4.8-20.1,13.4-20.8,27.2c-0.6,12.2,5.9,20.3,16,26.1c6.2,3.6,13,5.7,19.6,8.4c2.6,1.1,5,2.3,7.2,4.1 c6.3,5.1,5.3,13.7-2.1,17.1c-4,1.8-8.1,2.3-12.5,1.8c-6.7-0.7-13.1-2.4-19.1-5.4c-3.5-1.8-4.6-1.3-5.7,2.5c-1,3.3-1.8,6.6-2.7,10 c-1.2,4.5-0.7,5.5,3.6,7.5c5.5,2.5,11.3,3.8,17.2,4.7c4.6,0.7,4.8,0.9,4.9,5.7c0.1,2.2,0.1,4.4,0.2,6.5c0.1,2.7,1.4,4.3,4.2,4.3 c3.2,0,6.4,0,9.6-0.2c2.6-0.1,4-1.5,3.9-4.2c0-3,0.1-6-0.1-8.9c-0.2-3,1.1-4.6,4-5.4c6.7-1.9,12.4-5.6,16.7-11 C399.607,153.63,394.607,131.93,377.107,122.63z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const AnalyticsSvg = ({
  fill = "white",
  style = undefined,
}: {
  fill: string;
  style: CSSProperties | undefined;
}) => {
  return (
    <svg
      style={style}
      fill={fill}
      version="1.1"
      id="Layer_1"
      viewBox="0 0 512.003 512.003"
    >
      <g>
        <g>
          <g>
            <path
              d="M136.586,170.408l-0.051-0.051V86.448c-38.622,6.17-68.267,39.62-68.267,79.949c0,44.706,36.369,81.067,81.067,81.067
				c17.101,0,32.956-5.35,46.046-14.421l-56.346-56.346C137.303,174.964,136.518,172.678,136.586,170.408z"
            />
            <path
              d="M229.803,156.942c-0.23-1.937-0.521-3.857-0.879-5.751c-0.111-0.572-0.205-1.135-0.324-1.707
				c-0.495-2.321-1.084-4.617-1.775-6.869c-0.034-0.137-0.068-0.273-0.111-0.401c-7.919-25.284-27.913-45.278-53.197-53.188
				c-0.119-0.043-0.247-0.077-0.367-0.111c-2.261-0.691-4.565-1.28-6.895-1.775c-0.572-0.119-1.152-0.222-1.724-0.324
				c-1.877-0.358-3.78-0.648-5.7-0.879c-0.913-0.102-1.835-0.188-2.756-0.265c-0.819-0.068-1.647-0.077-2.475-0.12v76.578h76.587
				c-0.043-0.845-0.06-1.698-0.128-2.534C229.982,158.709,229.905,157.821,229.803,156.942z"
            />
            <path d="M208.316,221.845c10.871-11.563,18.364-26.283,20.975-42.641h-63.625L208.316,221.845z" />
            <path
              d="M0,354.135c0,21.171,17.229,38.4,38.4,38.4h164.011l-12.8,51.2h-1.877c-23.526,0-42.667,19.14-42.667,42.667
				c0,4.71,3.823,8.533,8.533,8.533h204.8c4.719,0,8.533-3.823,8.533-8.533c0-23.526-19.14-42.667-42.667-42.667h-1.869l-12.8-51.2
				H473.6c21.18,0,38.4-17.229,38.4-38.4v-29.867H0V354.135z M219.998,392.535h72.004l12.8,51.2h-97.604L219.998,392.535z"
            />
            <path
              d="M473.603,17.068h-435.2c-21.171,0-38.4,17.229-38.4,38.4v251.733h512V55.468
				C512.003,34.297,494.774,17.068,473.603,17.068z M360.877,62.209c0.853-0.768,1.707-1.365,2.816-1.792
				c3.157-1.365,6.912-0.597,9.301,1.792c1.536,1.621,2.475,3.84,2.475,6.059s-0.939,4.437-2.475,6.059
				c-1.621,1.536-3.84,2.475-6.059,2.475s-4.446-0.939-6.059-2.475c-1.545-1.621-2.475-3.84-2.475-6.059
				S359.333,63.831,360.877,62.209z M315.736,59.735h17.067c4.719,0,8.533,3.823,8.533,8.533s-3.814,8.533-8.533,8.533h-17.067
				c-4.719,0-8.533-3.823-8.533-8.533S311.017,59.735,315.736,59.735z M247.367,170.933l-0.154,3.524l-0.162,0.145
				c-2.142,25.719-14.251,48.597-32.435,64.862c-0.119,0.137-0.162,0.316-0.299,0.452c-0.213,0.213-0.495,0.29-0.725,0.478
				c-17.237,14.993-39.671,24.141-64.256,24.141c-54.11,0-98.133-44.023-98.133-98.133c0-51.336,39.646-93.517,89.907-97.715
				l0.034-0.034l3.661-0.282c0.742-0.034,1.468,0.034,2.21,0.017c0.777-0.017,1.536-0.119,2.321-0.119
				c1.075,0,2.116,0.128,3.183,0.162c1.468,0.051,2.935,0.102,4.403,0.222c2.065,0.162,4.104,0.401,6.135,0.691
				c1.203,0.171,2.406,0.333,3.601,0.546c2.21,0.401,4.378,0.896,6.537,1.434c1.041,0.265,2.082,0.512,3.115,0.802
				c2.167,0.623,4.292,1.348,6.391,2.108c1.041,0.375,2.082,0.734,3.106,1.143c1.937,0.776,3.814,1.647,5.692,2.543
				c1.169,0.563,2.355,1.092,3.499,1.69c1.562,0.828,3.055,1.741,4.557,2.637c1.382,0.828,2.782,1.621,4.13,2.509
				c1.058,0.717,2.065,1.502,3.098,2.253c1.664,1.203,3.345,2.381,4.932,3.695c0.034,0.026,0.068,0.06,0.102,0.085
				c2.381,1.971,4.702,4.019,6.904,6.221c2.091,2.082,4.019,4.301,5.897,6.554c0.136,0.162,0.299,0.316,0.435,0.478
				c1.229,1.502,2.33,3.081,3.473,4.642c0.836,1.143,1.707,2.253,2.492,3.439c0.811,1.22,1.536,2.5,2.287,3.763
				c0.99,1.638,1.988,3.277,2.884,4.975c0.529,1.015,0.99,2.057,1.485,3.089c0.973,2.014,1.911,4.036,2.739,6.118
				c0.367,0.913,0.683,1.835,1.015,2.756c0.811,2.21,1.562,4.446,2.219,6.724c0.273,0.964,0.495,1.937,0.742,2.901
				c0.555,2.202,1.058,4.42,1.459,6.682c0.222,1.195,0.384,2.389,0.555,3.593c0.282,2.005,0.521,4.019,0.683,6.067
				c0.119,1.502,0.179,3.004,0.23,4.523c0.026,1.033,0.154,2.048,0.154,3.089c0,0.777-0.102,1.528-0.119,2.304
				C247.333,169.448,247.401,170.19,247.367,170.933z M298.669,281.601c0,4.71-3.814,8.533-8.533,8.533s-8.533-3.823-8.533-8.533
				v-25.6c0-4.71,3.814-8.533,8.533-8.533s8.533,3.823,8.533,8.533V281.601z M307.203,110.935c0-4.71,3.814-8.533,8.533-8.533
				h68.267c4.719,0,8.533,3.823,8.533,8.533c0,4.71-3.814,8.533-8.533,8.533h-68.267
				C311.017,119.468,307.203,115.645,307.203,110.935z M332.803,281.601c0,4.71-3.814,8.533-8.533,8.533
				c-4.719,0-8.533-3.823-8.533-8.533v-59.733c0-4.71,3.814-8.533,8.533-8.533c4.719,0,8.533,3.823,8.533,8.533V281.601z
				 M366.936,281.601c0,4.71-3.814,8.533-8.533,8.533s-8.533-3.823-8.533-8.533v-42.667c0-4.71,3.814-8.533,8.533-8.533
				s8.533,3.823,8.533,8.533V281.601z M401.069,281.601c0,4.71-3.814,8.533-8.533,8.533c-4.719,0-8.533-3.823-8.533-8.533v-102.4
				c0-4.71,3.814-8.533,8.533-8.533c4.719,0,8.533,3.823,8.533,8.533V281.601z M435.203,281.601c0,4.71-3.814,8.533-8.533,8.533
				s-8.533-3.823-8.533-8.533v-68.267c0-4.71,3.814-8.533,8.533-8.533s8.533,3.823,8.533,8.533V281.601z M432.728,116.993
				c-1.621,1.536-3.84,2.475-6.059,2.475s-4.446-0.939-6.059-2.475c-0.341-0.427-0.768-0.853-1.024-1.28
				c-0.341-0.512-0.597-1.024-0.768-1.536c-0.256-0.512-0.427-1.024-0.512-1.536c-0.085-0.597-0.171-1.195-0.171-1.707
				c0-0.512,0.085-1.109,0.171-1.707c0.085-0.512,0.256-1.024,0.512-1.536c0.171-0.512,0.427-1.024,0.768-1.536
				c0.256-0.427,0.683-0.853,1.024-1.28c3.157-3.157,8.875-3.157,12.117,0c1.536,1.621,2.475,3.755,2.475,6.059
				C435.203,113.239,434.264,115.372,432.728,116.993z M426.669,76.801h-25.6c-4.719,0-8.533-3.823-8.533-8.533
				s3.814-8.533,8.533-8.533h25.6c4.719,0,8.533,3.823,8.533,8.533S431.388,76.801,426.669,76.801z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MoneySvg = ({
  fill = "white",
  style = undefined,
}: {
  fill: string;
  style: CSSProperties | undefined;
}) => {
  return (
    <svg
      style={style}
      fill={fill}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 487.4 487.4"
    >
      <g>
        <g>
          <path
            d="M36.036,253.4c1.8,3.1,6.2,3.1,8,0l33.9-58.8c1.8-3.1-0.4-6.9-4-6.9h-18.5v-36.3c0-23.5,19.1-42.6,42.6-42.6h44.7V78
			h-44.7c-40.4,0-73.3,32.9-73.3,73.3v36.4h-18.6c-3.5,0-5.8,3.8-4,6.9L36.036,253.4z"
          />
          <circle cx="159.436" cy="389.6" r="49.5" />
          <circle cx="72.236" cy="389.6" r="16.6" />
          <circle cx="246.636" cy="389.6" r="16.6" />
          <path
            d="M290.036,291.8h-261.2c-15.1,0-27.4,12.3-27.4,27.4V460c0,15.1,12.3,27.4,27.4,27.4h261.1c15.1,0,27.4-12.3,27.4-27.4
			V319.2C317.436,304.1,305.136,291.8,290.036,291.8z M294.036,431.7c-1.6-0.3-3.2-0.4-4.9-0.4c-15.3,0-27.7,12.4-27.7,27.7
			c0,1.7,0.2,3.4,0.5,5.1h-203.4c0.5-2.2,0.8-4.4,0.8-6.8c0-15.3-12.4-27.7-27.7-27.7c-2.4,0-4.7,0.3-6.9,0.9v-85
			c2.2,0.6,4.5,0.9,6.9,0.9c15.3,0,27.7-12.4,27.7-27.7c0-1.2-0.1-2.3-0.2-3.4h202.7c-0.3,1.7-0.5,3.4-0.5,5.1
			c0,15.3,12.4,27.7,27.7,27.7c1.7,0,3.3-0.2,4.9-0.4v84H294.036z"
          />
          <path
            d="M451.436,234c-1.8-3.1-6.2-3.1-8,0l-33.9,58.8c-1.8,3.1,0.4,6.9,4,6.9h18.6V336c0,23.5-19.1,42.6-42.6,42.6h-44.8v30.7
			h44.7c40.4,0,73.3-32.9,73.3-73.3v-36.3h18.6c3.5,0,5.8-3.8,4-6.9L451.436,234z"
          />
          <circle cx="328.036" cy="97.8" r="49.5" />
          <circle cx="240.836" cy="97.8" r="16.6" />
          <circle cx="415.236" cy="97.8" r="16.6" />
          <path
            d="M458.636,0h-261.2c-15.1,0-27.4,12.3-27.4,27.4v140.8c0,15.1,12.3,27.4,27.4,27.4h261.1c15.1,0,27.4-12.3,27.4-27.4V27.3
			C485.936,12.2,473.736,0,458.636,0z M462.636,139.8c-1.6-0.3-3.2-0.4-4.9-0.4c-15.3,0-27.7,12.4-27.7,27.7c0,1.7,0.2,3.4,0.5,5.1
			h-203.4c0.5-2.2,0.8-4.4,0.8-6.8c0-15.3-12.4-27.7-27.7-27.7c-2.4,0-4.7,0.3-6.9,0.9v-85c2.2,0.6,4.5,0.9,6.9,0.9
			c15.3,0,27.7-12.4,27.7-27.7c0-1.2-0.1-2.3-0.2-3.4h202.7c-0.3,1.7-0.5,3.4-0.5,5.1c0,15.3,12.4,27.7,27.7,27.7
			c1.7,0,3.3-0.2,4.9-0.4v84H462.636z"
          />
        </g>
      </g>
    </svg>
  );
};
